import React from 'react';

import { useAppSelector } from '../../hooks';
import { TooltipTextContent } from './common';

export function FeaturePatternContainerTooltip(props: { guid: string }) {
  const featurePatternContainer = useAppSelector((state) => state.layout.featurePatternContainers[props.guid]);
  if (featurePatternContainer == null) {
    console.warn('Unable to find feature pattern container for tooltip.');
    return null;
  }

  return <TooltipTextContent text={`Feature Pattern Container ${featurePatternContainer.name}`} />;
}
